import React from 'react';
import { classnames } from 'helpers';
import './style.scss';

const Button = ({ onClick, title, wide, position = 'left' }) => {
  const ButtonComponent = () => (
    <button className="custom-button" onClick={onClick}>{title}</button>
  );
  if (wide) {
    return (
      <div className={classnames('button-wrapper', position)}>
        <ButtonComponent />
      </div>
    );
  }
  return (
    <ButtonComponent />
  );
}

export default Button;
